import React, { useEffect, useState } from 'react';

const ORDER = ['system', 'light', 'dark'];

const read = () => {
  try {
    const saved = window.localStorage.getItem('theme');
    return ORDER.includes(saved) ? saved : 'system';
  } catch {
    return 'system';
  }
};

/** Cycles system, light, dark. "System" follows the OS setting. */
export const ThemeToggle = () => {
  const [theme, setTheme] = useState(read);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'system') {
      root.removeAttribute('data-theme');
    } else {
      root.setAttribute('data-theme', theme);
    }
    try {
      window.localStorage.setItem('theme', theme);
    } catch {
      /* storage blocked; the choice lasts for this page view */
    }
  }, [theme]);

  const next = ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length];

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setTheme(next)}
      aria-label={`Theme: ${theme}. Switch to ${next}.`}
    >
      <span className="theme-key">theme</span>
      <span className="theme-value">{theme}</span>
    </button>
  );
};

export default ThemeToggle;
